export const countTrue = (obj: { [key: string]: boolean }) =>
  Object.keys(obj).filter(key => obj[key]).length;
